import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hospital': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M128 244v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zM268 256c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40zM192 340c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zM268 352c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40zM448 476v36h-448v-36c0-6.6 5.4-12 12-12h19.5v-379c0-11.6 10.7-21 24-21h88.5v-40c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24v40h88.5c13.3 0 24 9.4 24 21v379h19.5c6.6 0 12 5.4 12 12zM79.5 463h112.5v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5v-351h-64.5v24c0 13.3-10.7 24-24 24h-112c-13.3 0-24-10.7-24-24v-24h-64.5v351zM266 64h-26v-26c0-3.3-2.7-6-6-6h-20c-3.3 0-6 2.7-6 6v26h-26c-3.3 0-6 2.7-6 6v20c0 3.3 2.7 6 6 6h26v26c0 3.3 2.7 6 6 6h20c3.3 0 6-2.7 6-6v-26h26c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hospital.js
// module id = 1777
// module chunks = 0